import React from "react";
import { DATATEST } from "constants/integration";
import Tile from "components/icons/layout/tile";
import { Table as TableIcon } from "components/icons/table";
import { View } from "constants/product-collection";

export interface IViews {
    id: View;
    name: string;
    Icon?: React.ElementType;
    dataTest: string;
    subItems: any[];
    dataTestMenu?: string;
}

export const views: IViews[] = [
    {
        id: View.Tile,
        name: "Tile",
        Icon: Tile,
        dataTest: DATATEST.ASSORTMENTS.TILE_VIEW_BTN,
        subItems: [],
    },
    {
        id: View.Grid,
        name: "Grid",
        Icon: TableIcon,
        dataTest: DATATEST.ASSORTMENTS.GRID_VIEW_BTN,
        subItems: [],
    },
];
